const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const USER_ID = 'user_id'
const USER_NAME_KEY = 'user_name'
const USER_USERNAME_KEY = 'user_username'
const USER_AVATAR_KEY = 'user_avatar'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }
}

const UserStorageService = {
    save(id, name = null, username = null, avatar = null) {
        localStorage.setItem(USER_ID, id)
        if (name !== null) localStorage.setItem(USER_NAME_KEY, name)
        if (username !== null) localStorage.setItem(USER_USERNAME_KEY, username)
        if (avatar !== null) localStorage.setItem(USER_AVATAR_KEY, avatar)
    },

    get() {
        let user = {
            name: localStorage.getItem(USER_NAME_KEY),
            username: localStorage.getItem(USER_USERNAME_KEY),
            avatar: localStorage.getItem(USER_AVATAR_KEY)
        }
        Object.keys(user).forEach(key => {
            if (user[key] == 'null') user[key] = null
        })
        return user
    }
}

export default TokenService
export { TokenService, UserStorageService }
